import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import SelfServeDashboard from '../../../components/advertisers/accounts/SelfServeDashboard';
import CustomDashboard from '../../../components/advertisers/accounts/CustomDashboard';

class Dashboard extends Component {
  render() {
    const { user, account } = this.props;
    return (
      <div>
        {
          user.isCustomdash ? <CustomDashboard account={account} /> : 
            <SelfServeDashboard account={account} />
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user: { data: user }, advertiser: { accounts } } = state;
  const accountSlug = ownProps.params.accountSlug;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  return { user, account };
};

export default connect(mapStateToProps)(Dashboard);
